import * as React from "react";
import "./Homepage.css";
import { useNavigate } from "react-router-dom";

const Rcomponent = ({ isMobile, data, setHoveredLetter }) => {
  const router = useNavigate();
  return (
    <>

      {!isMobile ? (<svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 906.8 236.25"
        height="100%"
        width="150%"

      // style={{border:"1px solid black"}}
      >
        {/* MAIN BLUE HEADING */}
        <rect
          x="0"
          y="0"
          width="906.8"
          height="136.25"
          fill="transparent"
          onMouseEnter={() => setHoveredLetter("R")}
          onMouseLeave={() => setHoveredLetter(null)}
        />
        <foreignObject
          x="0.94"
          y="0.76"
          width="600"    // set your desired fixed width
          height="200"   // set enough height for all lines
        >
          <div
            xmlns="http://www.w3.org/1999/xhtml"
            style={{
              fontFamily: "Proxima Nova Black, Proxima Nova",
              fontSize: "52px",
              fontWeight: 800,
              color: data?.[0]?.titleColor,
              lineHeight: "1",
              wordWrap: "break-word",
            }}
          >

            {data?.[0]?.title?.split("/n").map((line, index) => (
              <React.Fragment key={index}>
                {line}
                <br />
              </React.Fragment>
            ))}



          </div>
        </foreignObject>

        {/* SUBTEXT */}


        <foreignObject
          x="1.94"
          y="164.3"
          width="500"
          height="100"
        >
          <div
            xmlns="http://www.w3.org/1999/xhtml"
            style={{
              fontFamily: "Proxima Nova Regular, Proxima Nova",
              fontSize: "22px",
              color: "black",
              lineHeight: "1.1",
              wordWrap: "break-word",
            }}
          >
            {data?.[0]?.subTitle?.split("/n").map((line, index) => (
              <React.Fragment key={index}>
                {line}
                <br />
              </React.Fragment>
            ))}
          </div>
        </foreignObject>

        {/* LINE + CIRCLE (BLUE) */}

        {/* PINK BUTTON TEXT + ARROW SHAPE */}
        <g transform="translate(0,-65)" onClick={() => router(data?.[0]?.buttonUrl)} onMouseEnter={() => setHoveredLetter("R")} onMouseLeave={() => setHoveredLetter(null)} style={{ cursor: "pointer" }} >
          <text
            transform="translate(669.72 146.72)"
            style={{
              fill: data?.[0]?.buttonColor,
              fontFamily: "Proxima Nova Bold",
              fontSize: 22,
              fontWeight: 700,
              cursor: "pointer"
            }}

          >
            {data?.[0]?.buttonText?.split("/n").map((line, index) => (
              <tspan key={index} x="0" y={index === 0 ? "-10" : 18.83 * index - 10}>
                {line}
              </tspan>
            ))}
          </text>

          <path
            d="M865.8,98.36h-241.08c-20.59,0-37.53,15.55-39.75,35.55h49.65l-14.41-14.41c-1.74-1.74-1.74-4.56,0-6.3,1.74-1.74,4.56-1.74,6.3,0l21.91,21.91c.9.9,1.32,2.08,1.3,3.26.03,1.17-.4,2.36-1.3,3.26l-21.91,21.91c-1.74,1.74-4.56,1.74-6.3,0-1.74-1.74-1.74-4.56,0-6.3l14.41-14.41h-49.65c2.22,19.99,19.16,35.55,39.75,35.55h241.08c22.09,0,40-17.91,40-40h0c0-22.09-17.91-40-40-40Z"
            style={{
              fill: "none",
              stroke: data?.[0]?.buttonColor,
              strokeWidth: 2,
              strokeLinejoin: "round",
              strokeLinecap: "round",
            }}
          />
          <rect
            x="575"
            y="85"
            width="330"
            height="115"
            fill="transparent"
            pointerEvents="all"
          />
        </g>
      </svg>) : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 663.05 170.47"
          width="100%"
        >
          {/* Description */}

          <foreignObject
            x="0"
            y="95.61"
            width="350"
            height="120"
          >
            <div
              xmlns="http://www.w3.org/1999/xhtml"
              style={{
                fontFamily: "Proxima Nova Regular",
                fontSize: "22px",
                color: "black",
                lineHeight: "1.1",
                wordWrap: "break-word",
              }}
            >
              {data?.[0]?.subTitle?.split("/n").map((line, index) => (
                <div key={index} style={{ lineHeight: "1.05" }}>
                  {line}
                </div>
              ))}
            </div>
          </foreignObject>

          {/* CTA Group */}


          {/* Heading */}


          <foreignObject
            x="144.94"
            y="-3"        // match the y from your <text> transform
            width="600"      // set your desired width
            height="200"     // enough height for all lines
          >
            <div
              xmlns="http://www.w3.org/1999/xhtml"
              style={{
                fontFamily: "Proxima Nova Black, Proxima Nova",
                fontSize: "39px",        // match your <text> font size
                fontWeight: 800,
                color: data?.[0]?.titleColor,
                lineHeight: "1.05",      // adjust line spacing
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
                alignItems: "flex-start",
                margin: 0,
                padding: 0,
              }}
            >
              {data?.[0]?.title?.split("/n")}
            </div>
          </foreignObject>
          <g onClick={() => router(data?.[0]?.buttonUrl)}>
            <text
              transform="translate(459.24 143.05)"
              style={{
                fontFamily: "Proxima Nova Bold",
                fontSize: "18.83px",
                fontWeight: 700,
                fill: data?.[0]?.buttonColor,
                cursor: "pointer",
              }}
            >
              {data?.[0]?.buttonText?.split("/n").map((line, index) => (
                <tspan key={index} x="0" y={index === 0 ? "-10" : 18.83 * index - 10}>
                  {line}
                </tspan>
              ))}
            </text>

            <path
              d="M627.02,101.26h-206.29c-17.62,0-32.12,13.31-34.01,30.42h42.49l-12.33-12.33c-1.49-1.49-1.49-3.9,0-5.39,1.49-1.49,3.9-1.49,5.39,0l18.75,18.75c.77.77,1.13,1.78,1.11,2.79.02,1.01-.34,2.02-1.11,2.79l-18.75,18.75c-1.49,1.49-3.9,1.49-5.39,0-1.49-1.49-1.49-3.9,0-5.39l12.33-12.33h-42.49c1.9,17.11,16.4,30.42,34.01,30.42h206.29c18.9,0,34.23-15.32,34.23-34.23s-15.32-34.23-34.23-34.23Z"
              style={{
                fill: "none",
                stroke: data?.[0]?.buttonColor,
                strokeWidth: 1.5,
                strokeLinecap: "round",
                strokeLinejoin: "round",
              }}
            />
          </g>
        </svg>
      )}
    </>
  );
};

export default Rcomponent;
